module.exports = __webpack_public_path__ + "img/pain-spot-5.f3611fcc.svg";